import { UseMutationOptions, useMutation as useMutationLib } from "@tanstack/react-query";
import fraction from "src/api/fraction";
import { ResponseError, useQuery, wrapSuperagentErrors } from "src/lib/react-query";

import { parsers, schemas } from "@fraction/shared";

export const useSubmitPartialApplicationMutation = (
  options: UseMutationOptions<schemas.Application, ResponseError, parsers.application.FullApplication> = {}
) =>
  useMutationLib({
    mutationFn: wrapSuperagentErrors(fraction.submitPartialApplication),
    ...options,
  });

export const useTestApplicationQuery = (type?: string) => {
  return useQuery({
    queryKey: ["testApplicationFetch", type],
    queryFn: () => (type ? fraction.getTestApplication(type) : undefined),
    enabled: !!type,
  });
};
